import { render, staticRenderFns } from "./emergencyPlanDemo.vue?vue&type=template&id=724bccee&scoped=true"
import script from "./emergencyPlanDemo.vue?vue&type=script&lang=js"
export * from "./emergencyPlanDemo.vue?vue&type=script&lang=js"
import style0 from "./emergencyPlanDemo.vue?vue&type=style&index=0&id=724bccee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724bccee",
  null
  
)

export default component.exports